const expoHallConfig = {
  locales: ['en', 'de', 'fr', 'it'],
  searchTerms: [
    'Charts',
    'DNA',
    'Professionals',
    'Storytelling',
    'Travel',
    'Records',
    'Research',
    'Preservation',
    'Family History',
    'Technology',
    'Connection',
    'Tree Chart',
    'Storytelling',
    'Search Family',
    'Society',
    'Association',
    'Library',
  ],
  promotionsPath: '/online-expo-hall',
}
const boothConfig = {
  platinumSponsors: ['ancestry', 'familysearch', 'myheritage', 'storied'],
  companiesExcludedInChat: [
    'MyHeritage',
    'Ancestry®',
    'Ancestry',
    'Sessions for Members of The Church of Jesus Christ of Latter-day Saints',
    'South Asia',
    'RootsTech España',
    'New Zealand Research',
    'नेपाली सामग्री (Nepali)',
    'Family Tree Maker',
  ],
}

export { expoHallConfig, boothConfig }
